import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { apiFetch, jsonHeaders } from "../api/api";
import logo from "../logo.png";

function getCriteria(password) {
  const length = (password || "").length >= 12;
  const upper = /[A-Z]/.test(password);
  const lower = /[a-z]/.test(password);
  const number = /[0-9]/.test(password);
  const special = /[^A-Za-z0-9]/.test(password);
  return { length, upper, lower, number, special };
}

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [newPassword, setNewPassword] = useState("");
  const [confirmNew, setConfirmNew] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const criteria = useMemo(() => getCriteria(newPassword), [newPassword]);

  useEffect(() => {
    if (!token) {
      setError("Missing or invalid reset link.");
    }
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    if (!token) return;
    setBusy(true);
    setError("");
    setSuccess("");
    if (!(criteria.length && criteria.upper && criteria.lower && criteria.number && criteria.special)) {
      setError("Password must be at least 12 characters and include uppercase, lowercase, number, and special character.");
      setBusy(false);
      return;
    }
    if (newPassword !== confirmNew) {
      setError("Passwords do not match");
      setBusy(false);
      return;
    }
    try {
      const res = await apiFetch("/password-reset/confirm", {
        method: "POST",
        headers: jsonHeaders(),
        body: JSON.stringify({ token, newPassword }),
      });
      setSuccess(res?.message || "Password reset successful.");
      setTimeout(() => navigate("/login"), 2500);
    } catch (e) {
      setError(e?.body?.error || e.message || "Reset failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div style={{ minHeight: "80vh", display: "flex", flexDirection: "column", alignItems: "center" }}>
      <div style={{ width: "100%", display: "flex", justifyContent: "center", marginTop: 32, marginBottom: 32 }}>
        <img src={logo} alt="Counselor Notes Logo" style={{ width: 400, maxWidth: "90vw" }} />
      </div>
      <div style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: "40vh", width: 360 }}>
        <h1 style={{ textAlign: "center" }}>Reset Password</h1>
        {!token && (
          <p style={{ color: "#b91c1c" }}>This link is invalid or expired. Please request a new reset link.</p>
        )}
        <form onSubmit={submit} style={{ width: "100%", display: "grid", gap: 12, marginTop: 24 }}>
          <input type="password" placeholder="New password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} required style={{ padding: 12, fontSize: 16, borderRadius: 6, border: "1px solid #cbd5e1" }} />
          <input type="password" placeholder="Confirm new password" value={confirmNew} onChange={(e) => setConfirmNew(e.target.value)} required style={{ padding: 12, fontSize: 16, borderRadius: 6, border: "1px solid #cbd5e1" }} />
          <div style={{ fontSize: 13, color: "#475569" }}>
            <div>{criteria.length ? "✓" : "✗"} At least 12 characters</div>
            <div>{criteria.upper ? "✓" : "✗"} Uppercase letter</div>
            <div>{criteria.lower ? "✓" : "✗"} Lowercase letter</div>
            <div>{criteria.number ? "✓" : "✗"} Number</div>
            <div>{criteria.special ? "✓" : "✗"} Special character</div>
          </div>
          <button type="submit" disabled={busy || !token} style={{ padding: 12, fontSize: 16, background: "#2563eb", color: "#fff", border: "none", borderRadius: 6, cursor: busy ? "not-allowed" : "pointer" }}>{busy ? "Resetting…" : "Reset password"}</button>
        </form>
        {error && <div style={{ color: "#b91c1c", marginTop: 12 }}>{error}</div>}
        {success && <div style={{ color: "#065f46", marginTop: 12 }}>{success}</div>}
        <div style={{ marginTop: 16 }}>
          <Link to="/login" style={{ color: "#2563eb", textDecoration: "none", fontWeight: 600 }}>Back to Login</Link>
        </div>
      </div>
    </div>
  );
}
